const languageActionTypes = {
    SET_CURRENT_LANGUAGE_SUCCESS: 'SET_CURRENT_LANGUAGE_SUCCESS',
    SET_CURRENT_LANGUAGE_FAILURE: 'SET_CURRENT_LANGUAGE_FAILURE',

    GET_CURRENT_LANGUAGE: 'GET_CURRENT_LANGUAGE'
};

export default languageActionTypes;